<template>
    <div class="video-page">
        <div class="container">
            <div class="page-title">
                <h1>
                    <span v-if="globalLang == ''">видео</span>
                    <span v-if="globalLang == 'kz/'">видео</span>
                    <span v-if="globalLang == 'en/'">video</span>
                </h1>
            </div>
            <videoItems></videoItems>
            <transition
                name="fade"
                mode="out-in"
            >
                <div class="btn-pagination" v-if="!hidePaginBtn">
                    <a href="#" @click.prevent="paginationNews">Загрузить еще</a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import videoItems from '@/components/video-page/video-item.vue'
    // import salesFilter from '@/components/realestate/sales-filter.vue'
    export default {
        name: 'news--page',
        components: {
            videoItems,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                count: 9,
                page: 1,
            }
        },
        computed: mapGetters({
            pageSetup: 'loadVideoPage',
            videoPageCount: 'loadVideoPageCount',
            hidePaginBtn: 'loadHidePaginBtnVideo',
        }),
        methods: {
            paginationNews() {
                // this.count = this.count + 2;
                this.page = this.page + 1;
                if (this.page < this.videoPageCount) {
                    this.ajaxInit();
                } else if (this.page == this.videoPageCount) {
                    this.ajaxInit();
                }

                if (this.page >= this.videoPageCount) {
                   this.$store.commit('videoHidePaginate', true); 
                }
               
               
                // console.log(this.count, 'NEWS')
            },
            ajaxInit() {
                axios.get(window.urlSales + window.GlobalLang + '/wp-json/wp/v2/video?per_page=' + this.count + '&page=' + this.page).then(async (response) => {
                    // console.log(response)
                    this.$store.commit('videoItemsPaginateAdd', response.data);
                });
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.videoItems.length > 0) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                // store.dispatch('getVideoPage');
                store.dispatch('getVideoItems').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'video';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/video-page/video-page.scss';
    @import '@/styles/components/video-page/respond/video-page-respond.scss';
    // @import '@/styles/respond/video/video-respond.scss';
</style>